import { put, takeEvery, all, call, select } from 'redux-saga/effects';
import { setAction } from '../actions/projectsPage';
import { setAction as setProfileAction } from 'redux/actions/profile';
import actionTypes from '../../../redux/actions/action-types';
import {
  getTeamChartsSearchWithTeamid,
  getChartsTagsWithTeamid,
  getTeamUsersWithTeamid,
  getTeamChartsWithTeamid,
  getTeamIdWithCMSLicense
} from '../../../api/cloudApiGenerated';
import { cloneDeep, merge } from 'lodash';

export function* getCharts() {
  const { page, pageSize } = yield select((state) => state.chartsPage);
  const { team } = yield select((state) => state.profile);

  yield put(
    setAction({
      page,
      pageSize,
      charts: [null]
    })
  );
  let { query, selectCreatorValue, selectSortValue, selectValue } = yield select((state) => state.chartsPage);

  let mapQueryToEndpoint = function () {
    selectValue = (selectValue || []).map((a) => a.id);

    let isValidSearch = query?.length > 0 || selectValue.length !== 0 || selectCreatorValue !== undefined;

    const orderBy = [
      [0, 'latest'],
      [1, 'created'],
      [2, 'name']
    ].find((x) => x[0] === selectSortValue.id)[1];
    const passedParams = [query, selectValue.toString(), selectCreatorValue?.id ?? '', orderBy, page, pageSize];

    return isValidSearch
      ? getTeamChartsSearchWithTeamid(team.id, ...passedParams)
      : getTeamChartsWithTeamid(team.id, orderBy, page, pageSize);
  };

  if (team?.id) {
    const response = yield call(mapQueryToEndpoint);

    if (response.data) {
      //Remove html tags from old titles
      response.data.forEach((element) => (element.name = (element.name ?? '').replace(/<[^>]+>/g, '')));

      yield put(
        setAction({
          page,
          pageSize,
          charts: response.data,
          pageCount: response.pageCount
        })
      );
    }
  }
}

export function* getTags() {
  let team = yield select((state) => state.profile.team);
  const data = yield call(getChartsTagsWithTeamid, team.id);
  yield put(
    setAction({
      tags: data.data
    })
  );
}

export function* getCreators() {
  let team = yield select((state) => state.profile.team);

  try {
    const data = yield call(getTeamUsersWithTeamid, team.id);
    yield put(
      setAction({
        creators: data
      })
    );
  } catch (error) {
    //TODO do something with the error message
  }
}

export function* pageUpdate() {
  window.scrollTo(0, 0);
  // Not immediately seeing any better ways to go about
  // scrolling the projects view in the general case.
  // It would be ideal to just find the closest scroll context

  // To any degree I'm undecided to which extent
  // `ProjectsView`s should be separated  .
  const $modalContainer = document.querySelector('.modal__container.overflow-y-auto');
  if ($modalContainer) {
    $modalContainer.scrollTo(0, 0);
  }
}

export function* getTeamId(props) {
  try {
    const data = yield call(getTeamIdWithCMSLicense);
    console.log(data);
    const team = {
      id: data.team_id
    };
    yield put(setProfileAction({ team: team }));
  } catch (error) {
    //TODO do something with the error message
  }
}

export function* updateChart(props) {
  const { project, updatedProps } = props.data;
  const { charts } = yield select((state) => state.chartsPage);

  const newCharts = cloneDeep(charts);
  let index = newCharts.findIndex((x) => x.id == project.id);
  merge(newCharts[index], updatedProps);

  yield put(
    setAction({
      charts: newCharts
    })
  );
}

/** Watch functions */
export function* watchSetSelectFilter() {
  yield takeEvery(actionTypes.chartsPage.setSelectFilter, getCharts);
}
export function* watchGetCharts() {
  yield takeEvery(actionTypes.chartsPage.getCharts, getCharts);
}
export function* watchGetTags() {
  yield takeEvery(actionTypes.chartsPage.getTags, getTags);
}
export function* watchGetCreators() {
  yield takeEvery(actionTypes.chartsPage.getCreators, getCreators);
}
export function* watchPageUpdate() {
  yield takeEvery(actionTypes.chartsPage.pageUpdate, pageUpdate);
}
export function* watchUpdateChart() {
  yield takeEvery(actionTypes.chartsPage.updateChart, updateChart);
}
export function* watchGetTeamId() {
  yield takeEvery(actionTypes.chartsPage.getTeamId, getTeamId);
}

export default function* rootSaga() {
  yield all([
    watchGetCharts(),
    watchSetSelectFilter(),
    watchGetTags(),
    watchGetCreators(),
    watchPageUpdate(),
    watchUpdateChart(),
    watchGetTeamId()
  ]);
}
